export { default } from './CompleteRegistration';
